<script>
  import { getContext, onMount } from 'svelte';
  import TextInput from '../../../../components/inputs/text';
  import TextAreaInput from '../../../../components/inputs/textarea';
  import ProgramInput from '../../../../components/inputs/program';
  import CoordinatorInput from '../../../../components/inputs/coordinator';
  import CategoryInput from '../../../../components/inputs/category';
  import AnnualScheduleInput from '../../../../components/inputs/schedule';
  import DateInput from '../../../../components/inputs/date';
  import TimeInput from '../../../../components/inputs/time';
  import LeaderInput from '../../../../components/inputs/leader';
  import Form from '../../../../components/inputs/form';
  import { gql } from 'apollo-boost';
  import moment from 'moment';

  import { PROGRAM } from '../../../../graphql/programs';
  import {
    addNotification,
    ICONS
  } from '../../../../utils/notifications.store';

  export let value;
  export let review = false;

  const client = getContext('apollo');

  async function getProgram(id) {
    addNotification({ message: 'Loading Program Data', icon: ICONS.LOADING });
    try {
      const { data } = await client.query({
        query: PROGRAM,
        variables: { id: id }
      });

      // guards
      if (!data.program.category) {
        data.program.category = {};
      }

      if (!data.program.secondaryCategory) {
        data.program.secondaryCategory = {};
      }

      addNotification({
        message: 'Loaded Program Data',
        icon: ICONS.SUCCESS,
        time: 2000
      });

      value.date = new Date(value.date);

      // if (!value.constraintCapacityTotal) {
      value.constraintCapacityTotal = data.program.constraints.capacity;
      // }

      // if (!value.constraintStaff) {
      value.constraintStaff = data.program.constraints.staff;
      // }

      value.communications = data.program.communications.map(communication => {
        return {
          id: communication.id,
          type: communication.type,
          subject: communication.subject,
          body: communication.body,
          useParent: true,
          parent: communication.id
        };
      });

      value.program = data.program;
    } catch (e) {
      addNotification({
        message: 'There was an error loading Program Data',
        icon: ICONS.ERROR,
        time: 3000
      });
      error = e;
    }
  }

  async function onProgramChange(e) {
    e.preventDefault();
    await getProgram(e.target.value);
    return false;
  }

  function onChangeDate(evt) {

    console.log('on change date', evt);

    if (!evt.detail[0]) {
      return null
    }

    value.registrationOpenDate = moment(new Date(evt.detail[0][0]))
      .date(15)
      .subtract(1, 'month')
      .hour(9)
      .minute(0)
      .second(0)
      .toDate();

    value.date = new Date(evt.detail[0][0])

  }



</script>

<div>
  <Form>
    <div class="form-group">
      <ProgramInput review="{review}" bind:value="{value.program.id}" on:change="{onProgramChange}" label="Program"
        placeholder="Program"></ProgramInput>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-6">
        <div class="form-group">
          <DateInput bind:value="{value.date}" on:change="{onChangeDate}" label="Event Date" placeholder="Event Date">
          </DateInput>
        </div>
      </div>
      <div class="cell small-12 medium-3">
        <div class="form-group">
          <TimeInput id="start-time" bind:value="{value.startTime}" label="Start Time" placeholder="Start Time">
          </TimeInput>
        </div>
      </div>
      <div class="cell small-12 medium-3">
        <div class="form-group">
          <TimeInput id="end-time" bind:value="{value.endTime}" label="End Time" placeholder="End Time"></TimeInput>
        </div>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-3">
        <div class="form-group">
          <TextInput bind:value="{value.constraintCapacityTotal}" label="Event Capacity" placeholder="Event Capacity">
          </TextInput>
        </div>
      </div>
      <div class="cell small-12 medium-3">
        <div class="form-group">
          <TextInput bind:value="{value.constraintStaff}" label="Support Team" placeholder="Support Team"></TextInput>
        </div>
      </div>
      <div class="cell small-12 medium-3">
        <div class="form-group">
          <TimeInput id="staff-start-time" bind:value="{value.staffStartTime}" label="Support Team Start Time"
            placeholder="Support Team Start Time"></TimeInput>
        </div>
      </div>
      <div class="cell small-12 medium-3">
        <div class="form-group">
          <TimeInput id="staff-end-time" bind:value="{value.staffEndTime}" label="Support Team End Time"
            placeholder="Support Team End Time"></TimeInput>
        </div>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="form-group">
          <LeaderInput bind:value="{value.leader.id}" label="Event Leader"></LeaderInput>
        </div>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="form-group">
          <TextAreaInput bind:value="{value.notes}" label="Notes" placeholder="Notes"></TextAreaInput>
        </div>
      </div>
    </div>
  </Form>
</div>